import { Grid, Typography } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";

import { leadingZerosDateFormat } from "../../../common/helpers/formatDateTime";
import { TextFieldLight } from "../../../common/components/styled/styled";

export const FormDobRow = ({
  edit,
  maxWidth,
}: {
  edit: boolean | null;
  maxWidth: string;
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation("talentProfile");

  return (
    <>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("dob")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          name="dob"
          control={control}
          rules={{ required: true }}
          render={({ field }) =>
            edit ? (
              <DesktopDatePicker
                {...field}
                disableFuture={true}
                value={field.value || null}
                format={leadingZerosDateFormat}
                onChange={(newDate: Date | null) => field.onChange(newDate)}
                slots={{ textField: TextFieldLight }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { input: { textAlign: "center" }, maxWidth },
                    error: !!errors.dob,
                  },
                }}
              />
            ) : (
              <Typography>
                {field.value && format(field.value, leadingZerosDateFormat)}
              </Typography>
            )
          }
        />
      </Grid>
    </>
  );
};
